// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"004ecd8f","453":"491149c0","455":"8f077d90"}[chunkId] + ".chunk.js";
};